import appSettings from 'wanderu-config';
import { range } from 'wanderu-utils';

const S3_URL = appSettings.config.s3.staticAssetsUrl;
const S3_BUCKET_PATH = `${S3_URL}react-ui/media/about-us`;
const CANONICAL_URL = 'https://wanderu.com';

const BLOG_URL = `${CANONICAL_URL}/blog`;
const CAREER_PAGE_URL = '/about-us/careers/';
const CHIKU_URL = `${BLOG_URL}/wanderu-welcomes-a-new-adventurer-meet-chiku/`;
const PRESS_PAGE_URL = `${BLOG_URL}/press/`;

const FOUNDER_LINKEDIN_URL_1 = 'https://www.linkedin.com/in/polinafashion/';
const FOUNDER_LINKEDIN_URL_2 = 'https://www.linkedin.com/in/igor-bratnikov-25799113/';

const LINKEDIN_LOGO_URL = `${S3_BUCKET_PATH}/linkedin.svg`;
const TWITTER_LOGO_URL = `${S3_BUCKET_PATH}/twitter.svg`;

const AWARDS_IMAGE = `${S3_BUCKET_PATH}/awards-image.png`;
const CHIKU_IMAGE = `${S3_BUCKET_PATH}/chiku-image.png`;
const FOUNDERS_IMAGE_1 = `${S3_BUCKET_PATH}/founders-image1.png`;
const FOUNDERS_IMAGE_2 = `${S3_BUCKET_PATH}/founders-image2.png`;
const HERO_HEADER = `${S3_BUCKET_PATH}/about-us-header.png`;
const PARTNERS_IMAGE = `${S3_BUCKET_PATH}/partners-image.png`;
const PRESS_QUOTE_IMAGE = `${S3_BUCKET_PATH}/press-quote.svg`;
const STAR_URL = `${S3_BUCKET_PATH}/reviews-5-stars.svg`;

const PARTNER_EMAIL = 'partners@wanderu.com';

function createCarouselTemplate(numberOfImages, namePrefix, srcPrefix, labelPrefix, contentPrefix) {
    return range(numberOfImages).reduce((arr, item, index) => {
        const translationIndex = index + 1;
        const name = `${namePrefix}${translationIndex}`;
        const source = srcPrefix.replace('{translationIndex}', translationIndex);
        const label = `${labelPrefix}${translationIndex}`;
        const content = `${contentPrefix}${translationIndex}`;

        return [
            ...arr,
            {
                content,
                label,
                name,
                source,
            },
        ];
    }, []);
}

function createSourceAndContentTemplate(numberOfImages, contentPrefix, sourcePrefix) {
    return range(numberOfImages).reduce((arr, item, index) => {
        const translationIndex = index + 1;
        const content = `${contentPrefix}${translationIndex}`;
        const source = sourcePrefix.replace('{translationIndex}', translationIndex);

        return [
            ...arr,
            {
                content,
                source,
            },
        ];
    }, []);
}

const PARTNER_LOGOS = createSourceAndContentTemplate(
    8,
    'partners-carrier-icon',
    `${S3_BUCKET_PATH}/partners-carrier-icon{translationIndex}.png`,
);

const PRESS_CAROUSEL_DATA = createSourceAndContentTemplate(
    5,
    'about-us-press-quote-content',
    'about-us-press-quote-source{translationIndex}',
);

const REVIEW_CAROUSEL_DATA = createCarouselTemplate(
    10,
    'about-us-reviews-name',
    `${S3_BUCKET_PATH}/reviews-source{translationIndex}.png`,
    'about-us-reviews-label',
    'about-us-reviews-content',
);

const FOUNDER_DATA = [
    {
        founderDescription: 'about-us-founders-description1',
        founderImage: FOUNDERS_IMAGE_1,
        founderLabel: 'about-us-founders-label1',
        isMirrored: false,
        linkedInUrl: FOUNDER_LINKEDIN_URL_1,
    },
    {
        founderDescription: 'about-us-founders-description2',
        founderImage: FOUNDERS_IMAGE_2,
        founderLabel: 'about-us-founders-label2',
        isMirrored: true,
        linkedInUrl: FOUNDER_LINKEDIN_URL_2,
    },
];

export {
    AWARDS_IMAGE,
    BLOG_URL,
    CAREER_PAGE_URL,
    CHIKU_IMAGE,
    CHIKU_URL,
    FOUNDER_DATA,
    HERO_HEADER,
    LINKEDIN_LOGO_URL,
    PARTNERS_IMAGE,
    PARTNER_EMAIL,
    PARTNER_LOGOS,
    PRESS_CAROUSEL_DATA,
    PRESS_PAGE_URL,
    PRESS_QUOTE_IMAGE,
    REVIEW_CAROUSEL_DATA,
    S3_URL,
    STAR_URL,
    TWITTER_LOGO_URL,
};
